// extracted by mini-css-extract-plugin
module.exports = {"container":"TagContainer_container__waBYg"};